module.exports = __webpack_public_path__ + "img/facebook_extension.acc1b314.gif";